
import { Component, Vue } from "vue-property-decorator";
import { UserModule } from "@/store/modules/user";
import { veriFyCode } from "@/api/autheticationApi/users";

@Component({
  name: "VerifyCode",
  components: {}
})
export default class extends Vue {
  $refs!: {
    form: HTMLFormElement;
  };
  private valid = false;
  private codeSent = false;
  private loading = false;
  private mobile = "";
  private code = "";

  private async verifyCode() {
    this.loading = true;
    try {
      if (this.code.length != 4) {
        alert("کد اشتباه است");
        return;
      }
      await UserModule.VerifyCode({
        code: this.code,
        mobile: UserModule.mobile
      });
      this.loading = false;
      if (UserModule.verfied)
        if (UserModule.isAdmin) this.$router.push("/");
        else this.$router.push("/complexes");
    } catch (error) {
      this.loading = false;
    }
  }
  private validationForm() {
    this.$refs.form.validate();
  }
}
